import React from "react";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "../ui/dialog";

interface DialogModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	description?: string;
	children?: React.ReactNode;
	footer?: React.ReactNode;
}

export default function DialogModal({
	open,
	onOpenChange,
	title,
	description,
	children,
	footer,
}: DialogModalProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>

					{description && <DialogDescription>{description}</DialogDescription>}
				</DialogHeader>

				{children && <div>{children}</div>}

				{footer && <DialogFooter>{footer}</DialogFooter>}
			</DialogContent>
		</Dialog>
	);
}
